import { baseRoute } from '../../constants/routes';
export const API_SETTINGS_ROUTE = baseRoute + '/user/profile';
export const SEND_API_SETTINGS = 'SEND_API_SETTINGS';
export const SEND_API_SETTINGS_SUCCESS = 'SEND_API_SETTINGS_SUCCESS';
export const GET_API_SETTINGS = 'GET_API_SETTINGS';
export const GET_API_SETTINGS_SUCCESS = 'GET_API_SETTINGS_SUCCESS';
export const PUT_API_KEY = 'PUT_API_KEY';
export const PUT_API_KEY_SUCCESS = 'PUT_API_KEY_SUCCESS';
export const API_ZAPIER_KEY_ROUTE = baseRoute+'/user/api-key';
export const API_ZAPIER_DISCONNECT = 'API_API_ZAPIER_DISCONNECT';
export const API_ZAPIER_DISCONNECT_SUCCESS = 'API_API_ZAPIER_DISCONNECT_SUCCESS';
export const API_ZAPIER_DISCONNECT_ROUTE = baseRoute + '/user/disconnect-zapier';